import { useEffect, useState, FC } from 'react';
import { RenderOnScrollProps } from './props';

const DISTANCE_FROM_BOTTOM_TO_LOAD_MORE_RESULTS = 300;

export const RenderOnScroll: FC<RenderOnScrollProps> = ({ renderLimit, scrollRef, children }) => {
  const [limit, setLimit] = useState(renderLimit);

  const onScroll = function () {
    const elem = scrollRef?.current;

    if (elem) {
      const distanceFromBottom = elem.scrollHeight - elem.offsetHeight - elem.scrollTop;

      if (distanceFromBottom < DISTANCE_FROM_BOTTOM_TO_LOAD_MORE_RESULTS) {
        setLimit(limit + renderLimit);
      }
    }
  };

  useEffect(() => {
    scrollRef.current && scrollRef.current.addEventListener('scroll', onScroll);

    return () => {
      scrollRef.current && scrollRef.current.removeEventListener('scroll', onScroll);
    };
  }, [limit]);

  return children.slice(0, limit);
};
